import { render, staticRenderFns } from "./AppButtonTrueOrFalse.vue?vue&type=template&id=727b67ed"
import script from "./AppButtonTrueOrFalse.vue?vue&type=script&lang=js"
export * from "./AppButtonTrueOrFalse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports